import { Component, HostListener, OnInit } from '@angular/core';
import { map } from 'rxjs/operators';
import { EnumSolicitacaoCompraFornecedorStatus } from 'src/app/enum-types/enum-solicitacao-compra-fornecedor-status';
import { EnumStatusCotacao } from 'src/app/enum-types/enum-status-cotacao';
import { JwtService } from 'src/app/jwt.service';
import { SolicitacaoCompraFornecedor } from 'src/app/persistences/solicitacao-compra-fornecedor';
import { CORE_IMPORTS } from 'src/app/providers/module-providers';
import { CotacaoService } from 'src/app/services/cotacao.service';

@Component({
	standalone: true,
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
	imports: [CORE_IMPORTS]
})

export class HomeComponent implements OnInit {
    
    nFinalizadas: number;
	nEdicao: number;
	nNovas: number;
	innerWidth: number = window.innerWidth;
	colunas: string = this.nColunas();

	constructor(
		private cotacaoService: CotacaoService,
		private jwtService: JwtService)
    {}    


	ngOnInit () {
		this.jwtService.validarAcessToken();
		this.load();
	}

	// TODO: Colocar esses métodos em um service
	load () {
		this.cotacaoService.getSolicitacoes().pipe(
			map((val: SolicitacaoCompraFornecedor[]) =>
				val.sort((a, b) => {
					let diff = this.getStatusCotacao(b) - this.getStatusCotacao(a)
					if (diff == 0) {
						diff = b.solicitacaoCompra.nrSolicitacao - a.solicitacaoCompra.nrSolicitacao;
					}
					return diff;
				}))
			).subscribe((val: SolicitacaoCompraFornecedor[]) =>
				{
					this.nFinalizadas = 0;
					this.nEdicao = 0;
					this.nNovas = 0;					
					for (const cot of val) {
						if (this.getIcon(cot) == "check_circle") {
							this.nFinalizadas++;
						}
						else if (this.getIcon(cot) == "error") {
							this.nEdicao++;
						}
						else if (this.getIcon(cot) == "") {
							this.nNovas++;
						}
					}
				}, (e: Response) => {
					this.jwtService.dialogMensagemSessaoExpirada();
				});
	}


	getStatusCotacao(cot: SolicitacaoCompraFornecedor): EnumStatusCotacao {	
		if (cot.flStatus === EnumSolicitacaoCompraFornecedorStatus[EnumSolicitacaoCompraFornecedorStatus.FECHADO][0]) {//SolicitacaoCompraFornecedorStatus.FECHADO[0]) {
			return EnumStatusCotacao.FECHADA;
		}
		//parcial

		for (let i = 0; i < cot.solicitacaoCompraItemCotacoes.length; i++) {
			const it = cot.solicitacaoCompraItemCotacoes[i];
			if (it.vlBruto != 0) {
				return EnumStatusCotacao.PARCIAL;
			}
		}
		return EnumStatusCotacao.ABERTA;
	}


	getIcon(cot: SolicitacaoCompraFornecedor): string {
		switch (this.getStatusCotacao(cot)) {
			case EnumStatusCotacao.FECHADA:
				return "check_circle";
			case EnumStatusCotacao.PARCIAL:
				return "error";
			case EnumStatusCotacao.ABERTA:
				return "";
		}
	}


	@HostListener('window:resize')
	onResize() {
		this.innerWidth = window.innerWidth;
	}

	nColunas(): string {
		if (this.innerWidth > 900) {
			return "3";
		}
		return "5";
	}

	logout() {
		this.jwtService.logout();
	}
}